import { useState } from "react";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";

const useDoNotCallLead = () => {
  const { handleConfirmUpdate, isError, lead, isSuccess, editCustomerError } =
    useLeadInfo();

  const [doNotCall, setDoNotCall] = useState(lead?.data?.lead?.do_not_call);

  return {
    lead,
    doNotCall,
    handleConfirmUpdate,
    isError,
    isSuccess,
    setDoNotCall,
    editCustomerError,
  };
};

export default useDoNotCallLead;
